import type { StringGUID } from "@pdfking/tfunc"
import { FullMethodDispatcher } from "@pdfking/tfunc"

import type { VirtualFile } from "../types/files/VirtualFile"
import { VirtualFileType } from "../types/files/VirtualFileType"

export const FileContentGUID = FullMethodDispatcher<[VirtualFile], StringGUID>({
  [VirtualFileType.GENERATED_FILE]: file => file.guid,
  [VirtualFileType.REMOTE_FILE]: file => file.guid,
  [VirtualFileType.REMOTE_FILE_CHUNK]: file => file.content.guid,
  [VirtualFileType.SINGLE_PAGE_IMAGE]: file => file.content.guid,
  [VirtualFileType.SINGLE_PAGE_PDF]: file => file.content.guid,
  [VirtualFileType.MULTI_PAGE_PDF]: file => file.content.guid,
  [VirtualFileType.ZIP_FILE]: file => file.content.guid,
})
